export const SET_MERCHANTS_AND_OFFERS_RS = 'merchants/SET_MERCHANTS_AND_OFFERS_RS';
export const SET_MERCHANTS_AND_OFFERS_RS_LOADED = 'merchants/SET_MERCHANTS_AND_OFFERS_RS_LOADED';
